import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

type MuiCssBaseline = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiCssBaseline'];
  defaultProps?: ComponentsProps['MuiCssBaseline'];
  variants?: ComponentsVariants['MuiCssBaseline'];
};

export const MuiCssBaseline: MuiCssBaseline = {
  styleOverrides: `
    @font-face {
      font-family: 'Noto Sans';
      src: url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-black-webfont.woff2), url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-black-webfont.woff);
      font-weight: 900;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'Noto Sans';
      src: url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-extrabold-webfont.woff2), url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-extrabold-webfont.woff);
      font-weight: 800;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'Noto Sans';
      src: url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-bold-webfont.woff2), url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-bold-webfont.woff);
      font-weight: 700;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'Noto Sans';
      src: url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-semibold-webfont.woff2), url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-semibold-webfont.woff);
      font-weight: 600;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'Noto Sans';
      src: url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-regular-webfont.woff2), url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-regular-webfont.woff);
      font-weight: 500;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'Noto Sans';
      src: url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-light-webfont.woff2), url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-light-webfont.woff);
      font-weight: 400;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'Noto Sans';
      src: url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-blackitalic-webfont.woff2), url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-blackitalic-webfont.woff);
      font-weight: 900;
      font-style: italic;
      font-display: swap;
    }
    @font-face {
      font-family: 'Noto Sans';
      src: url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-extrabolditalic-webfont.woff2), url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-extrabolditalic-webfont.woff);
      font-weight: 800;
      font-style: italic;
      font-display: swap;
    }
    @font-face {
      font-family: 'Noto Sans';
      src: url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-bolditalic-webfont.woff2), url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-bolditalic-webfont.woff);
      font-weight: 700;
      font-style: italic;
      font-display: swap;
    }
    @font-face {
      font-family: 'Noto Sans';
      src: url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-semibolditalic-webfont.woff2), url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-semibolditalic-webfont.woff);
      font-weight: 600;
      font-style: italic;
      font-display: swap;
    }
    @font-face {
      font-family: 'Noto Sans';
      src: url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-italic-webfont.woff2), url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-italic-webfont.woff);
      font-weight: 500;
      font-style: italic;
      font-display: swap;
    }
    @font-face {
      font-family: 'Noto Sans';
      src: url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-lightitalic-webfont.woff2), url(https://oct.assets.appreciatehub.com/fonts/notosans/notosans-lightitalic-webfont.woff);
      font-weight: 400;
      font-style: italic;
      font-display: swap;
    }
  `,
};
